module.exports = __webpack_public_path__ + "static/img/introduceContent2.2e02bf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduceContent2.png
// module id = ePMf
// module chunks = 0